import PS from 'settings';
import mixPanel from 'mixpanel-browser';

export const shouldApplied = PS.isMixpannelUsed;
if (shouldApplied && !window.isMaxPanelApplied) {
  window.isMaxPanelApplied = true;
  mixPanel.init(PS.mixPanelToken);
}
